module.exports = __webpack_public_path__ + "media/images/admin/icons/smile-27f2efd881fad623383bc8231c3708bb.svg";